import {Component, DestroyRef, inject, ChangeDetectionStrategy} from '@angular/core';
import { AnalyticsService } from '../analytics.service';
import {TerminalModule, TerminalService} from "primeng/terminal";
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-events-debugger',
  imports: [
    TerminalModule
  ],
  templateUrl: './events-debugger.component.html',
  styleUrl: './events-debugger.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [TerminalService],
})
export class EventsDebuggerComponent {
  analytics = inject(AnalyticsService);
  terminalService = inject(TerminalService)
  destroyRef = inject(DestroyRef);
  constructor() {
    this.terminalService.commandHandler
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(cmd => {
        if (cmd === 'clear') {
          this.analytics.clearEvents();
          this.terminalService.sendResponse('Events cleared');
          return;
        }
        if (cmd === 'id') {
          this.terminalService.sendResponse(`userId: \`${this.analytics.userId()}\` sessionId: \`${this.analytics.sessionId()}\``);
          return;
        }
        if (cmd === 'events') {
          this.terminalService.sendResponse(this.analytics.events().map(e => JSON.stringify(e)).join('\n'));
          return;
        }
      })
  }
}
